// 3rd party imports
import * as React from 'react';
import { inject, observer } from 'mobx-react';

// mobx
import { AuthState } from 'sources';
import { UserAuthStore } from 'stores';

interface RenderWrapperProps {
  userAuth?: UserAuthStore;
  component: any;
  render?: any;
  renderProps?: any;
}

@inject('userAuth')
@observer
export class RenderWrapper extends React.Component<RenderWrapperProps> {
  public render() {
    switch (this.props.userAuth.authenticated) {
      case AuthState.UNKNOWN:
        return null;
      case AuthState.FALSE:
        this.props.userAuth.initiateLogin(true);

        return null;
      case AuthState.TRUE:
        const C = this.props.component;

        return this.props.render ? this.props.render(this.props.renderProps) : <C {...this.props.renderProps} />;
    }
  }
}
